import Game from "../../../../../src/Game";
import CalculationLine from "../entities/CalculationLine";
import { CENTER_ANGLE_COLOR, CIRCUM_ANGLE_COLOR } from "../../../../../src/types/Config";
import { eventBus, EnumEventBus } from "./EventBus";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { CALC_LINES_COORD } from "../types/Config";

export default class CalculationLineManager {
  Game = Game.getInstance();
  isCompletedCircleAnim: boolean = true;
  firstCalcLine!: CalculationLine;
  secondCalcLine!: CalculationLine;
  constructor(isVertical: boolean) {
    this.generateCalcLines(isVertical);
    eventBus.on(EnumEventBus.setCalcLines, (degrees: number[]) => this.setDegrees(degrees));
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false))
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.isCompletedCircleAnim = true);
  }

  generateCalcLines(isVertical: boolean) {
    const dim = this.Game.getDim();
    const verticalCoords = [
      {
        x: dim.WIDTH / 2 - 50,
        y: dim.HEIGHT / 2 + 200,
      },
      {
        x: dim.WIDTH / 2 + 350,
        y: dim.HEIGHT / 2 + 200
      }
    ]
    const coords = isVertical ? verticalCoords : CALC_LINES_COORD;
    this.firstCalcLine = new CalculationLine(coords[0], CENTER_ANGLE_COLOR.textColor, ["a", "c"]);
    this.secondCalcLine = new CalculationLine(coords[1], CIRCUM_ANGLE_COLOR.textColor, ["b", "d"]);
  }
  setDegrees(degrees: number[]) {
    if (!this.isCompletedCircleAnim) {
      return
    }
    this.firstCalcLine.updateDegrees(degrees[0], degrees[2]);
    this.secondCalcLine.updateDegrees(degrees[1], degrees[3]);
  }
  setAllVisible(v: boolean) {
    this.firstCalcLine.visible = v;
    this.secondCalcLine.visible = v;
  }
  setVisible(index: number, v: boolean) {
    if (index == 0) {
      this.firstCalcLine.visible = v;
    } else if (index == 1) {
      this.secondCalcLine.visible = v;
    }
  }
}